import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F26.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame26() {
    let [isLoading, setIsLoading] = useState(false)
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, [])

    if (isLoading === true) {
        return (<div className="F1_image"></div>)
    } else {
        return (
            <div className="F26_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F26_entryBox">
                    <div className="F26_paragraph">
                        {language === 'english' ?
                            <p className="F26_paragraphEnglish">Saira has arrived late at school because she had her first menstruation this morning. Everyone including her teacher are surprised because Saira is never late from school. When her teacher inquiries about the reason for being late, Saira lowers her head instead. Teacher ask Saira to see her in the break.</p>
                            :
                            <p className="F26_paragraphUrdu"> سائرہ آج اسکول لیٹ پہنچی ہے کیونکہ آج اس کو پہلی دفعہ ماہواری ہوئی ہے۔ سائرہ کی ٹیچر سمیت سب اس بات پر حیران ہیں کیونکہ سائرہ کھبی اسکول سے غیر حاضر نہیں ہوئی۔ جب سائرہ کی ٹیچر نے اس سے لیٹ آنے کی وجہ پوچھی تو کچھ بولنے کی بجائے سائرہ نے اپنا سر جھکا لیا۔ سائرہ کی ٹیچر سمجھ گئیں اور اس کو بریک میں ملنے کے لئے کہا۔</p>
                        }
                    </div>

                    <div className="F26_timeline">
                        <div className='F26_timelineBar'>
                            <div className='F26_timelineFill'></div>
                            <span className='F26_timelineText'>3/19</span>
                        </div>
                    </div>

                    <div className="F26_nextFrames">
                        <div className="F26_nextFrame1"></div>
                        <div className="F26_nextFrame2"></div>
                        <div className="F26_nextFrame3"></div>
                    </div>

                    <div className='F26_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(3)) }} className='F26_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame26;